<template>
  <div class="login-title flex-r-center">
    <div class="card-width flex-center-between">
      <div class="fw flex-center pointer" @click="goHome">
        <img class="icon-logo mr10 pointer" src="@/assets/logo-red.png" alt />
        <div class="fc3 pointer">{{ '全国电子印章服务平台（广烁刻企）' }}</div>
      </div>
<!--      <div v-if="goHomeArrow">-->
<!--        <span @click="handleReturnLogin" class="fc3 fz14 pointer">返回登录>></span>-->
<!--      </div>-->
<!--      <div v-if="goReturnArrow">-->
<!--        <span @click="handleReturn" class="fc3 fz14 pointer">返回>></span>-->
<!--      </div>-->
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      goHomeArrow: false,
      goReturnArrow: false,
      baseName: process.env.VUE_APP_API_BASE_NAME,
    };
  },
  mounted() {
    let home = ["/register/register", "/findPassword/findPassword"];
    if (this.$route.path == "/login") {
      this.goHomeArrow = false;
      this.goReturnArrow = false;
    } else if (home.includes(this.$route.path)) {
      this.goHomeArrow = true;
      this.goReturnArrow = false;
    } else {
      this.goReturnArrow = true;
      this.goHomeArrow = false;
    }
  },
  methods: {
    goHome() {
      // this.$router.push({
      //     path: "/index",
      // });
    },
    handleReturnLogin() {
        this.$store.commit("account/setUser", null);
        this.$auth.removeKqToken();
        window.location.href = 'http://sign.lngsyz.com/#/login'
        // this.$router.push({
        //     path: "/login",
        // });
    },
    handleReturn() {
      this.$router.go(-1);
    },
  },
};
</script>
<style lang="less" scoped>
.icon-logo {
  width: 24px;
  height: 24px;
}

.login-title {
  position: fixed;
  top: 0;
  z-index: 10;
  width: 100%;
  height: 56px;
  line-height: 56px;
  margin: 0 auto;
  background: #fff;
  font-size: 20px;
}
</style>
